import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateOrganisationTeamMemberMutationVariables = Types.Exact<{
  data: Types.UpdateOrganisationTeamMemberInput;
}>;


export type UpdateOrganisationTeamMemberMutation = { __typename?: 'Mutation', updateTeamMember: { __typename?: 'OrganisationTeamMember', id: string, role: Types.OrganisationTeamRole } };


export const UpdateOrganisationTeamMemberDocument = gql`
    mutation UpdateOrganisationTeamMember($data: UpdateOrganisationTeamMemberInput!) {
  updateTeamMember(data: $data) {
    id
    role
  }
}
    `;
export type UpdateOrganisationTeamMemberMutationFn = Apollo.MutationFunction<UpdateOrganisationTeamMemberMutation, UpdateOrganisationTeamMemberMutationVariables>;

/**
 * __useUpdateOrganisationTeamMemberMutation__
 *
 * To run a mutation, you first call `useUpdateOrganisationTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganisationTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganisationTeamMemberMutation, { data, loading, error }] = useUpdateOrganisationTeamMemberMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrganisationTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganisationTeamMemberMutation, UpdateOrganisationTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganisationTeamMemberMutation, UpdateOrganisationTeamMemberMutationVariables>(UpdateOrganisationTeamMemberDocument, options);
      }
export type UpdateOrganisationTeamMemberMutationHookResult = ReturnType<typeof useUpdateOrganisationTeamMemberMutation>;
export type UpdateOrganisationTeamMemberMutationResult = Apollo.MutationResult<UpdateOrganisationTeamMemberMutation>;
export type UpdateOrganisationTeamMemberMutationOptions = Apollo.BaseMutationOptions<UpdateOrganisationTeamMemberMutation, UpdateOrganisationTeamMemberMutationVariables>;